<template>
  <div id="swipeBanner" class="swipe-banner">
    <van-swipe
        class="my-swipe"
        :autoplay="data.autoSwitch? data.intervalTime : 0"
        :show-indicators="false"
        :height="data.height"
    >
      <van-swipe-item v-for="(image, index) in data.items" :key="index">
        <img :src="basePath + '/nonlogin/slideShow/attachment/' + image.imgURL + '.htm'" lazy-load @click="swipeHandle(image)" :height="data.height"/>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
import { baseURL, locationTo } from "@/utils/url";
export default {
  name: "SwipeBanner",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          intervalTime: 3000,
          autoSwitch: false,
          items: []
        }
      }
    }
  },
  data() {
    return {
      basePath: baseURL
    }
  },
  methods: {
    locationTo,
    swipeHandle(image) {
      if (image.linkURL) {
        this.locationTo(image.linkURL)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swipe {
  img{
    width: 100%;
  }
}
</style>
